module.exports = __webpack_public_path__ + "static/media/hire-1.18c60131.svg";